export default class FanClubController {
  constructor(resource) {
    this._resource = resource;
  }

  async create(progressiveOffer) {
    await this._resource('discount-configuration').save(progressiveOffer);
  }

  async getAll() {
    const res = await this._resource('discount-configuration').get();
    return res.json();
  }

  async get(progressiveOfferId) {
    return this._resource(`discount-configuration/${progressiveOfferId}`).get();
  }

  async getExceptions() {
    const res = await this._resource('discount-configuration-exceptions').get();
    return res.json();
  }

  async update(progressiveOffer) {
    return this._resource(`discount-configuration`).update(progressiveOffer);
  }

  async delete(progressiveOfferId) {
    return this._resource(
      `discount-configuration/${progressiveOfferId}`
    ).delete();
  }
}
